import React from 'react';

interface FormErrorListProps {
  errors: Record<string, string | null | undefined>;
  show: boolean;
}

export const FormErrorList: React.FC<FormErrorListProps> = ({ errors, show }) => {
  if (!show) {
    return null;
  }

  const errorEntries = Object.entries(errors).filter(([, error]) => error != null && error !== '');

  if (errorEntries.length === 0) {
    return null;
  }

  return (
    <ul className="errorList">
      {errorEntries.map(([field, error]) => (
        <li key={field}>
          <span>{field}:</span> {error}
        </li>
      ))}
    </ul>
  );
};
